'use client'

import { Anchor, Box, Flex, Text } from '@mantine/core'

import { GTM_EVENTS } from '@/configs/dataTrackingEvent'
import type { HomePageV2CTABanner } from '@/services/cms/homePageV2'
import { trackGtmEvent } from '@/services/dataTracking'
import { getPayloadAssetURL } from '@/utils/payload'

interface CTABannerProps {
  data: HomePageV2CTABanner
  page: string
}

export default function CTABanner({ data, page }: CTABannerProps) {
  const featureImageUrl = getPayloadAssetURL(data.featureImage)
  const isPrimary = data.cta.variant !== 'secondary'

  return (
    <Box py={{ base: 64, md: 120 }}>
      <Box
        pos="relative"
        h={{ base: 520, md: 619 }}
        style={{
          borderRadius: 32,
          overflow: 'hidden',
          background:
            'linear-gradient(349deg,#E1E2E5 -34.83%,#95A2C4 -4.66%,#4F5C7D 12.82%,#243052 25.52%,#0A1021 44.58%,#040814 76.35%,#161616 124%)',
        }}
      >
        {featureImageUrl && (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          >
            <source src={featureImageUrl} type="video/mp4" />
          </video>
        )}
        <Flex
          pos="relative"
          direction="column"
          align="center"
          justify="flex-end"
          gap={{ base: 24, md: 32 }}
          px={{ base: 32, md: 64 }}
          pt={{ base: 48, md: 64 }}
          pb={{ base: 32, md: 64 }}
          h="100%"
        >
          <Text ta="center" fz={{ base: 24, lg: 28 }} lh="32px" fw={600} c="#F8F8F8">
            {data.title}
          </Text>
          <Anchor
            href={data.cta.link}
            underline="never"
            onClick={() =>
              trackGtmEvent({
                event: GTM_EVENTS.PriceStartTradingClicked,
                page,
              })
            }
            style={{
              borderRadius: 10,
              padding: '10px 20px',
              fontSize: 14,
              fontWeight: 600,
              backgroundColor: isPrimary ? '#1199FA' : '#1199FA33',
              color: isPrimary ? '#fff' : '#92D1FF',
            }}
          >
            {data.cta.text}
          </Anchor>
        </Flex>
      </Box>
    </Box>
  )
}
